/* ============================================================
   BENLEE COMBAT — editorial runtime
   - Scroll reveal for [data-bl-reveal]
   - Parallax for [data-bl-parallax]
   - FAQ / Legal scrollspy + single-open accordions
   - Cart drawer cross-sell "+ Add" (re-renders Dawn's drawer)
   No dependencies. Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-bl-reveal]:not(.in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    var px = [].slice.call(document.querySelectorAll('[data-bl-parallax]'));
    if (reduce || !px.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      px.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-bl-parallax')) || 0.1;
        var frame = el.parentElement.getBoundingClientRect();
        var offset = frame.top + frame.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-offset * speed).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- scrollspy + single-open accordions (FAQ / Legal) ---------- */
  function initSpy(navSel, groupAttr) {
    document.querySelectorAll(navSel).forEach(function (nav) {
      var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
      if (!links.length) return;
      var groups = links.map(function (l) {
        return document.getElementById(l.getAttribute('href').slice(1));
      });
      function onScroll() {
        var y = window.scrollY + 130;
        var active = 0;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i] && groups[i].offsetTop <= y) active = i;
        }
        links.forEach(function (l, i) { l.classList.toggle('active', i === active); });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
      links.forEach(function (l) {
        l.addEventListener('click', function (e) {
          var target = document.getElementById(l.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          window.scrollTo({ top: target.offsetTop - 70, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.bl-fgroup').forEach(function (group) {
      var accs = group.querySelectorAll('details.bl-acc');
      accs.forEach(function (a) {
        a.addEventListener('toggle', function () {
          if (a.open) accs.forEach(function (o) { if (o !== a) o.open = false; });
        });
      });
    });
  }

  /* ---------- cart drawer cross-sell ---------- */
  function refreshCartDrawer(openAfter) {
    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && sections['cart-drawer']) {
          var tpl = document.createElement('template');
          tpl.innerHTML = sections['cart-drawer'];
          var fresh = tpl.content.querySelector('.drawer__inner');
          var current = drawerEl.querySelector('.drawer__inner');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
          } else if (fresh) {
            var host = drawerEl.querySelector('#CartDrawer') || drawerEl;
            host.appendChild(fresh.cloneNode(true));
          }
          drawerEl.classList.toggle('is-empty', !!tpl.content.querySelector('cart-drawer.is-empty, .drawer.is-empty'));
          if (typeof drawerEl.setHeaderCartIconAccessibility === 'function') {
            try { drawerEl.setHeaderCartIconAccessibility(); } catch (e) { /* noop */ }
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bdom = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var freshBubble = bdom.getElementById('shopify-section-cart-icon-bubble') || bdom.body;
          bubble.innerHTML = freshBubble.innerHTML;
        }
        if (openAfter && drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
      });
  }

  window.blRefreshCartDrawer = refreshCartDrawer;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bl-xadd[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '…';
    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCartDrawer(true);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Add';
      });
  });

  function init() {
    initReveal();
    initParallax();
    initSpy('.bl-fnav');
    initAccordions();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-init reveals for content injected by the theme editor */
  document.addEventListener('shopify:section:load', function () { initReveal(); initSpy('.bl-fnav'); initAccordions(); });
})();
